/* KarTex "Complete the look" behaviour (2026-10-03).
   Every [data-kx-kit-root] on the page: size pickers update the card price, Add adds one item,
   [data-kx-kit-all] adds every card inside [data-kx-kit] with its chosen size.
   Prices are cents in data-price; the currency comes from the root's data-currency. */
(function () {
  if (window.__kxKit) return;
  window.__kxKit = true;

  function init(root) {
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.getAttribute('data-currency') || 'USD' });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2); } };
    }
    function money(cents) { return fmt.format((cents || 0) / 100); }

    var toast = root.querySelector('[data-kx-kit-toast]'), timer;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-show');
      clearTimeout(timer);
      timer = setTimeout(function () { toast.classList.remove('is-show'); }, 3000);
    }
    function refreshBadge() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var link = document.querySelector('a[aria-label="Cart"]');
        if (!link) return;
        var badge = link.querySelector('.kx-header__cart-badge');
        if (!badge && cart.item_count > 0) { badge = document.createElement('span'); badge.className = 'kx-header__cart-badge'; link.appendChild(badge); }
        if (badge) badge.textContent = cart.item_count;
      }).catch(function () {});
    }
    function chosen(card) {
      var s = card.querySelector('select');
      return s ? { id: s.value, price: s.selectedOptions[0].getAttribute('data-price') }
               : { id: card.getAttribute('data-variant'), price: card.getAttribute('data-price') };
    }
    function add(items, label, btn) {
      if (btn) btn.disabled = true;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { showToast(label); refreshBadge(); })
        .catch(function () { showToast('Could not add to cart. Please pick a size.'); })
        .then(function () { if (btn) btn.disabled = false; });
    }

    root.querySelectorAll('[data-kx-kc]').forEach(function (card) {
      var sel = card.querySelector('select'), price = card.querySelector('[data-kx-kc-price]');
      if (sel && price) sel.addEventListener('change', function () { price.textContent = money(parseInt(chosen(card).price, 10)); });
      var btn = card.querySelector('[data-kx-kc-add]');
      if (btn) btn.addEventListener('click', function () { add([{ id: parseInt(chosen(card).id, 10), quantity: 1 }], 'Added to cart.', btn); });
    });

    var all = root.querySelector('[data-kx-kit-all]');
    if (!all) return;
    var kitCards = root.querySelectorAll('[data-kx-kit] [data-kx-kc]');
    var base = all.getAttribute('data-label') || 'Add all';
    function label() {
      var t = 0;
      kitCards.forEach(function (c) { t += parseInt(chosen(c).price, 10) || 0; });
      all.textContent = base + ' — ' + money(t);
    }
    kitCards.forEach(function (c) { var s = c.querySelector('select'); if (s) s.addEventListener('change', label); });
    label();
    all.addEventListener('click', function () {
      var items = [];
      kitCards.forEach(function (c) { items.push({ id: parseInt(chosen(c).id, 10), quantity: 1 }); });
      add(items, 'Added ' + items.length + ' items to cart.', all);
    });
  }

  function boot() { document.querySelectorAll('[data-kx-kit-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
